import { createRoute } from '@tanstack/react-router';

import { RootRoute } from '$/routes/RootRoute';

export const TermsOfServiceRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: '/tos',
}).lazy(() => import('./TermsOfServiceRoute.lazy').then((d) => d.LazyTosRoute));
